module.exports = __webpack_public_path__ + "static/media/room-12.5a2ab370.jpeg";